import { computed, Ref, watch } from "vue";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import type { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import { ListModeloVehiculoAction } from "../../actions/modeloVehiculoActions";

export function useModeloVehiculosList(params: Ref<PaginacionFilterParams>) {
  const queryClient = useQueryClient();

  // TanStack Query principal
  const query = useQuery({
    queryKey: ["ModeloVehiculosList", params],
    queryFn: () => ListModeloVehiculoAction(params.value),
    staleTime: 60 * 1000, // cache de 1 minuto
  });

  // Extraer datos en forma reactiva
  const modelos = computed(() => query.data.value?.data?.data?.modelosVehiculos || []);
  const total = computed(() => query.data.value?.data?.data?.total || 0);
  const totalPages = computed(() => query.data.value?.data?.data?.totalPages || 0);
  const currentPage = computed(() => query.data.value?.data?.data?.page || 1);

  // Prefetch cuando cambien los parámetros
  watch(
    params,
    (newParams) => {
      queryClient.prefetchQuery({
        queryKey: ["ModeloVehiculosList", newParams],
        queryFn: () => ListModeloVehiculoAction(newParams),
      });
    },
    { deep: true }
  );

  return {
    ...query, // => { data, isPending, isError, error, refetch, ... }
    modelos,
    total,
    totalPages,
    currentPage,
  };
}
